<template lang="pug">
  .analise
    h3.titulo-cadastar-foto Recall de Planta e Memorial
    el-card.card-container(shadow="hover")
      el-row(:gutter="20")
        el-col(:span="24")
          el-input(
            v-model="numeroProcesso",
            placeholder="Digite o número do processo",
            size="small",
            clearable,
            v-mask="'#########/####'"
          )
      el-row(:gutter="20", v-if="dadosProcesso").mt-2
        el-col(:span="24", v-if="erroGerarPlanilhaArcgis")
          span Erro ao gerar novo json junto ao arcgis, é necessario fazer manualmente
        el-col(:span="24")
          h4 Configuração de Recall
        el-col(:span="4")
          el-switch(v-model="formRecall.tramitar", active-text="Tramitar")
        el-col(:span="4")
          el-switch(v-model="formRecall.sistema", active-text="Sistema")
        el-col(:span="4")
          el-switch(v-model="formRecall.geomensor", active-text="Geomensor")
        el-col(:span="4")
          el-switch(v-model="formRecall.recall", active-text="Recall")
        el-col(:span="4")
          el-switch(v-model="formRecall.retornoArcGis", active-text="Retorno ArcGis")
        el-col(:span="4")
          el-switch(v-model="formRecall.processoEmRetificacao", active-text="Processo em Retificação")
        el-col(:span="4")
          el-switch(v-model="formRecall.substituirDocumentos", active-text="Substituir Documentos")
        el-col(:span="24")
          el-input(
            type="textarea",
            :rows="20",
            v-model="jsonRecall",
            placeholder="Digite o json de recall",
            size="small",
            clearable
          )
        el-col(:span="24")
          el-button(
            type="primary",
            size="small",
            @click="processarPlanta"
          ) Gerar Json
</template>
<script>

import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'

export default {

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      numeroProcesso: '',
      dadosProcesso: null,
      jsonRecall: null,
      erroGerarPlanilhaArcgis: false,
      formRecall: {
        tramitar: false,
        sistema: false,
        geomensor: true,
        recall: true,
        retornoArcGis: false,
        processoEmRetificacao: false,
        substituirDocumentos: true
      }
    }
  },

  methods: {
    ...mapActions({
      verificaProcesso: 'manutencao/verificaProcesso',
      geraJsonPlanilha: 'manutencao/geraJsonPlanilha',
      gerarPlantaMemorialJSON: 'manutencao/gerarPlantaMemorialJSON'
    }),
    processarPlanta () {
      const parseJson = JSON.parse(this.jsonRecall)
      this.gerarPlantaMemorialJSON({...this.formRecall, numeroProcesso: this.numeroProcesso, json: parseJson})
    }
  },
  watch: {
    numeroProcesso (val) {
      if (val.length === 14) {
        this.verificaProcesso(val)
          .then((data) => {
            this.dadosProcesso = data
            if (this.dadosProcesso.jsonPlanilha) {
              this.jsonRecall = this.dadosProcesso.jsonPlanilha
              // this.geraJsonPlanilha(JSON.parse(this.dadosProcesso.jsonPlanilha))
              //   .then((data) => {
              //     this.jsonRecall = JSON.stringify({
              //       identificacaoPlanilha: data.identificacaoPlanilha,
              //       perimetros: data.perimetros,
              //       responsavelTecnico: data.responsavelTecnico,
              //       municipioId: data.municipioId,
              //       municipiosId: data.municipiosId
              //     })
              //   })
              //   .catch(() => {
              //     this.erroGerarPlanilhaArcgis = true
              //   })
            }
          })
          .catch((err) => {
            this.notificarErro(err)
          })
      }
    }
  }
}

</script>
<style>
.label {
  font-weight: bold;
}

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.flex button {
  margin-bottom: 1em;
}

.flex .el-button span {
  display: flex;
}

.right {
  float: right;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.titulo-cadastar-foto {
  margin: 20px;
  color: #000;
}

.mt-2 {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/RecallPlanta.vue